import { createFileRoute } from "@tanstack/react-router";
import { IndustryDetailPage } from "@/components/site/IndustryDetailPage";
import { industryDetails } from "@/lib/industry-details";
import { generateServiceSchema, generateBreadcrumbSchema } from "@/components/site/Schema";

const data = industryDetails["professional-services"]!;

export const Route = createFileRoute("/industries/professional-services")({
  head: () => ({
    meta: [
      { title: data.metaTitle },
      { name: "description", content: data.metaDescription },
      { property: "og:title", content: data.metaTitle },
      { property: "og:description", content: data.metaDescription },
      { property: "og:url", content: "https://finendra.com/industries/professional-services" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: data.metaTitle },
      { name: "twitter:description", content: data.metaDescription },
    ],
    links: [{ rel: "canonical", href: "https://finendra.com/industries/professional-services" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateServiceSchema({
            name: "Agency & Professional Services Accounting",
            description: data.metaDescription,
            url: "https://finendra.com/industries/professional-services",
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateBreadcrumbSchema([
            { name: "Home", url: "https://finendra.com" },
            { name: "Industries", url: "https://finendra.com/industries" },
            {
              name: "Professional Services",
              url: "https://finendra.com/industries/professional-services",
            },
          ]),
        ),
      },
    ],
  }),
  component: () => <IndustryDetailPage data={data} />,
});
